import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";
import styled from "styled-components";

// Styled Components
// Estilos del contenedor principal
const ContactSection = styled.div`
  text-align: center;
  padding: 50px 20px;
  background-color: #fff;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
`;

const Divider = styled.div`
  width: 100px;
  height: 2px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;

const ContactContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
`;

const ContactItem = styled.div`
  flex: 1 1 200px;
  max-width: 250px;
  text-align: left;

  svg {
    color: #f7bc0c;
    font-size: 1.1rem;
    margin-right: 10px;
    vertical-align: middle;
  }

  h3 {
    font-size: 1rem;
    font-weight: bold;
    margin: 10px 0;
    color: #f7bc0c;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    color: #041c40;
    line-height: 1.5;
  }
`;



const ContactInfo = (props) => {
  return (
    <ContactSection>
      <Title>Our Contact Info</Title>
      <Divider />
      <ContactContainer>
        {/* Ubicaciones */}
        <ContactItem>
          <div className="d-flex align-items-start pb-2">
            <FaMapMarkerAlt />
            <h3 className="m-0">Our Locations</h3>
          </div>
          <p>P.O. BOX 2 HAMPTON BAYS, NY 1194</p>
        </ContactItem>

        {/* Teléfonos */}
        <ContactItem>
          <div className="d-flex align-items-start pb-2">
            <FaPhoneAlt />
            <h3 className="m-0">Phone Numbers</h3>
          </div>
          <p>631-488-5832</p>
        </ContactItem>

        {/* Correos */}
        <ContactItem>
          <div className="d-flex align-items-start pb-2">
            <FaEnvelope />
            <h3 className="m-0">Emails</h3>
          </div>
          <p>constructiondgpus@gmail.com</p>
        </ContactItem>

        {/* Sitio web */}
        <ContactItem>
          <div className="d-flex align-items-start pb-2">
            <FaGlobe />
            <h3 className="m-0">Website</h3>
          </div>
          <p>https://www.dgpconstructions.com</p>
        </ContactItem>
      </ContactContainer>
    </ContactSection>
  );
};

export default ContactInfo;
